import type { RenderElementProps } from 'slate-react'

export default function Table({ attributes, children }: RenderElementProps) {
  return (
    <table>
      <tbody {...attributes}>{children}</tbody>
    </table>
  )
}
